export enum Country {
  FINLAND = 'finland',
  SWEDEN = 'sweden',
  UK = 'uk',
}
